import { ICollectionProducts } from "../interfaces/shopify";
import { client } from "./shopifyClient";
export const getFeatureProduct = async (
  category: string,
  sortKey: string
): Promise<ICollectionProducts> => {
  const query = `
{
  collectionByHandle(handle: "${category}") {
    id
    title
    products(first: 15, sortKey: ${sortKey}) {
      edges {
        node {
          id
          handle
          title
          description
          tags
          images(first: 1) {
            edges {
              node {
                url
                altText
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                 amount
                 currencyCode
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

  const response = await client.request(query);

  const collection = response.data.collectionByHandle;

  const products =
    collection.products.edges?.map((edge: any) => edge.node) ?? [];

  const parentProducts = products.filter((p: any) =>
    p.tags?.includes("shsdparentproduct")
  );

  return {
    categoryTitle: collection.title,
    products: parentProducts,
    banner: collection.banner ?? null,
  };
};
